import * as am4core from '@amcharts/amcharts4/core'

const vuetifyTheme = {
  theme: {
    primary: '#009aff',
    accent: '#009aff'
  }
}

const am4themesEfdTheme = target => {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color('#0099ff'),
      am4core.color('#6870db'),
      am4core.color('#dc67cf'),
      am4core.color('#67dc8d'),
      am4core.color('#b9dc66'),
      am4core.color('#e9dc5a')
    ]
  }
}

const am4themesFunTheme = target => {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color('#84C5E1'),
      am4core.color('#177e89'),
      am4core.color('#db3a34'),
      am4core.color('#ffc857'),
      am4core.color('#6870db'),
      am4core.color('#dc67cf'),
      am4core.color('#67dc8d'),
      am4core.color('#b9dc66'),
      am4core.color('#e9dc5a'),
      am4core.color('#015eab'),
      am4core.color('#186BB2'),
      am4core.color('#2F7ABA'),
      am4core.color('#4689C1'),
      am4core.color('#5D97C9'),
      am4core.color('#74A6D1'),
      am4core.color('#8BB5D8'),
      am4core.color('#A2C4E0'),
      am4core.color('#B9D2E8'),
      am4core.color('#D0E1EF'),
      am4core.color('#E7F0F7')
    ]
  }
}

const am4themesRmTheme = target => {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color('#005ba9'),
      am4core.color('#e1e1e1'),
      am4core.color('#003052'),
      am4core.color('#b3b3b3'),
      am4core.color('#8ad4eb'),
      am4core.color('#5f6b6d'),
      am4core.color('#99bddd'),
      am4core.color('#374649')
    ]
  }
}

const am4themesEfdThemeAchr = target => {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color('#015eab'),
      am4core.color('#186BB2'),
      am4core.color('#2F7ABA'),
      am4core.color('#4689C1'),
      am4core.color('#5D97C9'),
      am4core.color('#74A6D1'),
      am4core.color('#8BB5D8'),
      am4core.color('#A2C4E0'),
      am4core.color('#B9D2E8'),
      am4core.color('#D0E1EF'),
      am4core.color('#E7F0F7')
    ]
  }
}

const am4themesFunPalette = target => {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color('#177e89'),
      am4core.color('#084c61'),
      am4core.color('#db3a34'),
      am4core.color('#ffc857'),
      am4core.color('#0099ff'),
      am4core.color('#6870db'),
      am4core.color('#dc67cf'),
      am4core.color('#67dc8d'),
      am4core.color('#b9dc66'),
      am4core.color('#e9dc5a'),
      am4core.color('#015eab'),
      am4core.color('#186BB2'),
      am4core.color('#2F7ABA'),
      am4core.color('#4689C1'),
      am4core.color('#5D97C9'),
      am4core.color('#74A6D1'),
      am4core.color('#8BB5D8'),
      am4core.color('#A2C4E0'),
      am4core.color('#B9D2E8'),
      am4core.color('#D0E1EF'),
      am4core.color('#E7F0F7')
    ]
  }
}

export {
  vuetifyTheme,
  am4themesEfdTheme,
  am4themesEfdThemeAchr,
  am4themesRmTheme,
  am4themesFunPalette,
  am4themesFunTheme
}
